import styled from 'styled-components';

export const PageContainer = styled.div`
  margin: 8px;
  padding: 8px;
  background: #fff;
  height: calc(100% - 16px);
`;

export const AlertTime = styled.span`
  color: #0046ff;
  text-decoration: underline;
  cursor: pointer;
`;
